module.exports = __webpack_public_path__ + "img/tanom3.30ffb552.jpg";